export default __webpack_public_path__ + "static/media/error.e13beb65.svg";